import { AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';
import { ComponentProps, ReactNode } from 'react';
import { FilterAccordion } from '../FilterAccordion';

type ExpandableSectionProps = {
  defaultExpanded?: ComponentProps<typeof FilterAccordion>['defaultExpanded'];
  title: string;
  children: ReactNode;
};

export const ExpandableSection = (props: ExpandableSectionProps) => {
  return (
    <FilterAccordion defaultExpanded={props.defaultExpanded}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography fontSize="1rem">{props.title}</Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          backgroundColor: unifiedPlatformColorPalette.lightBackgroundDefault,
        }}
      >
        {props.children}
      </AccordionDetails>
    </FilterAccordion>
  );
};
